export const getOptions = (
  nav: string,
  api: string,
  type: string,
  columns: any[],
  rowKey: string,
  dateFilter?: { dateFilter: boolean },
) => ({
  nav,
  api,
  type,
  columns,
  rowKey,
  ...dateFilter,
})
